// extracted by mini-css-extract-plugin
module.exports = {"footerMiddleAuthorizeBinding":"ContentFooter_footerMiddleAuthorizeBinding__9vXvZ","zaloBtn":"ContentFooter_zaloBtn__1-e6E","zaloPayBtn":"ContentFooter_zaloPayBtn__212r9"};